/**
 * Hero Video Background Handler
 * Gestion optimisée de la vidéo background avec fallbacks
 */

(function($) {
  'use strict';

  // Check if user prefers reduced motion
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Initialize hero video
  function initHeroVideo() {
    const $heroVideo = $('.hero-video');

    if (!$heroVideo.length) return;

    // Handle reduced motion preference
    if (prefersReducedMotion) {
      handleReducedMotion($heroVideo);
      return;
    }

    // Handle mobile fallback
    if (window.innerWidth <= 768) {
      handleMobileFallback($heroVideo);
    }

    // Ensure video plays on load
    $heroVideo.each(function() {
      const video = this;

      // Force play attempt
      const playPromise = video.play();

      if (playPromise !== undefined) {
        playPromise
          .then(() => {
            // Video playing successfully
            console.log('Hero video playing');
          })
          .catch(error => {
            // Auto-play was prevented - show poster or fallback
            console.warn('Video autoplay prevented:', error);
            handleVideoError($(video));
          });
      }

      // Listen for video errors
      $(video).on('error', function() {
        console.error('Video failed to load');
        handleVideoError($(video));
      });

      // Optimize performance - pause video when not visible
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              video.play();
            } else {
              video.pause();
            }
          });
        }, { threshold: 0.25 });

        observer.observe(video);
      }
    });
  }

  // Handle reduced motion preference
  function handleReducedMotion($video) {
    $video.each(function() {
      this.pause();

      // Show poster image instead
      const poster = $(this).attr('poster');
      if (poster) {
        $(this).closest('.video-background').append(
          `<img src="${poster}" alt="" class="hero-video-fallback" style="opacity: 1;">`
        );
        $(this).hide();
      }
    });
  }

  // Handle mobile fallback
  function handleMobileFallback($video) {
    $video.each(function() {
      const mobileFallback = $(this).data('mobile-fallback');

      if (mobileFallback) {
        // Replace video with mobile image
        $(this).closest('.video-background').append(
          `<img src="${mobileFallback}" alt="" class="hero-video-fallback" style="opacity: 1;">`
        );
        $(this).remove();
      }
    });
  }

  // Handle video loading errors
  function handleVideoError($video) {
    const poster = $video.attr('poster');
    const mobileFallback = $video.data('mobile-fallback');
    const fallbackImage = mobileFallback || poster;

    if (fallbackImage) {
      $video.closest('.video-background').append(
        `<img src="${fallbackImage}" alt="" class="hero-video-fallback" style="opacity: 1;">`
      );
      $video.hide();
    }
  }

  // Initialize on document ready
  $(document).ready(function() {
    initHeroVideo();
  });

})(jQuery);
